import { useIsMobile } from "../../hooks/useIsMobile";
import DesktopLayout from "../DesktopLayout/DesktopLayout";
import MobileLayout from "../MobileLayout/MobileLayout";
import "./ResponsiveLayout.css";

export default function ResponsiveLayout() {

    const isMobile = useIsMobile();

    if (isMobile) {
        return (
            <MobileLayout />
        )
    } else {
        return (
            <DesktopLayout />
        );
    }
}
